module.exports = __webpack_public_path__ + "img/feibiaoN134-1.67516f0e.png";